var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUppercase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15,
    fill: "currentColor",
    viewBox: "0 0 19 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15 1.253a.6.6 0 0 0-1.128-.016L1.753 9.85H1.73v.064L.241 13.837a.6.6 0 0 0 1.122.425l1.22-3.212h5.704l1.111 3.196a.6.6 0 0 0 1.134-.393L6.15 1.253ZM3.037 9.85l2.52-6.645L7.87 9.85H3.037Zm8.564-8.7a.6.6 0 0 0-.6.6v12.3a.6.6 0 0 0 .6.6h3.3a3.9 3.9 0 0 0 1.552-7.48 3.45 3.45 0 0 0-2.301-6.02h-2.55Zm4.8 3.45a2.25 2.25 0 0 1-2.25 2.25h-1.95v-4.5h1.95a2.25 2.25 0 0 1 2.25 2.25Zm-1.5 8.85h-2.7v-5.4h2.7a2.7 2.7 0 1 1 0 5.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUppercase);
export default __webpack_public_path__ + "static/media/uppercase.6ad9a24df8d44d2ed9429b15894e4646.svg";
export { ForwardRef as ReactComponent };